export default "__VITE_ASSET__DXP_RBvk__"